var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundSignin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 296.785,
    height: 300.583,
    viewBox: "0 0 296.785 300.583",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535",
    transform: "translate(-2.615 -12.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M950.667,2774l118.192,68.716a41.841,41.841,0,0,1,18.542,35.351c.05,24.567-20.194,34.852-20.194,34.852l-276.54,160.814s-.117-282.567,0-288.733,1.311-11.85,10.983-11.85",
    transform: "translate(-788 -2761)",
    fill: "#e93f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M950.667,2774l118.192,68.716a41.841,41.841,0,0,1,18.542,35.351c.05,24.567-20.194,34.852-20.194,34.852l-12.556,7.931L863.467,2774",
    transform: "translate(-788 -2761)",
    fill: "#bb493c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundSignin);
export default __webpack_public_path__ + "static/media/Background_signin.c2585b8534764fac170160278f71be49.svg";
export { ForwardRef as ReactComponent };